import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import * as types from '../../constants/prayerFeatureActionTypes';
import * as consts from '../../constants/prayerFeatureConstants';
import Text from '../common/input/text';

function CommentForm({ memberId, prayer, addComment, onActionComplete, commentHasError, commentHasBanWord }) {
    const [comment, setComment] = useState('');
    const [updateCharsLeft, setUpdateCharsLeft] = useState(0);
    const [postError, setPostError] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const handleAddComment = e => {
        setSubmitting(true);
        e.preventDefault();
        const callback = (response, hasError) => {
            if (hasError) {
                setPostError(true);
            }
            else {
                setComment('');
                setUpdateCharsLeft(0);
                onActionComplete({ ...response, success: true, confirmationMessage: consts.ADD_COMMENT_SUCCESS });
            }
            setSubmitting(false);
        };
        addComment(comment, prayer.postId, memberId !== prayer.postedUserId ? prayer.postedUserId : null, callback);
    };

    return (
        <div className="comment-form-container">
            <div className="card">
                <div className="input-header">{consts.POST_DISCLAIMER}</div>
                <Text name="text" placeholder="Add an update..." value={comment}
                    onChange={e => {
                        setComment(e.target.value);
                        setUpdateCharsLeft(e.target.value.length);
                    }}
                    maxSize={250}
                    rows="3"
                    minLength={25}
                    className="text-input"
                />
                <div className="input-btn">
                    <div className="list-item-col__action">
                        <button type="button" className={"list-item-col__action--cancel  btn btn-link-style" + (updateCharsLeft === 0 ? " disabled-style" : "")}
                            disabled={updateCharsLeft === 0} onClick={() => { setComment(''); setUpdateCharsLeft(0); }}>
                            Cancel
                         </button>
                        <button type="button" className={"list-item-col__action--save btn btn-link-style postBtn" + (updateCharsLeft < 25 ? " disabled-style" : "")}
                            disabled={updateCharsLeft < 25 || submitting} onClick={handleAddComment}>
                            Post
                        </button>
                    </div>
                </div>
                {updateCharsLeft !== 0 &&
                    <div className={(updateCharsLeft < 25) ? "character-count-msg warning" : "character-count-msg character-count-background-color"}> {updateCharsLeft} / 250</div>
                }
            </div>
            <Modal
                className="prayerpost-modal"
                isOpen={commentHasError && postError}
                centered
            >
                <ModalBody>
                    {commentHasBanWord ? consts.BAN_WORD_ERROR : < div className="prayer-comment-fail-msg">{consts.ADD_COMMENT_ERROR}</div>}
                </ModalBody>
                <ModalFooter>
                    <div className="prayerpost-error-okay">
                        <button
                            type="button"
                            className="btn text-btn"
                            onClick={() => {
                                setPostError(false);
                            }}
                        >
                            OKAY
                        </button>
                    </div>
                </ModalFooter>
            </Modal>
        </div>
    );
}

const mapStateToProps = state => {
    return {
        commentHasError: state.prayerFeature.commentHasError,
        commentHasBanWord: state.prayerFeature.commentHasBanWord
    };
};

const mapDispatchToProps = dispatch => {
    return {
        addComment: (comment, postId, postUserId, callback) => {
            dispatch({ type: types.ADD_COMMENT, comment, postId, postUserId, callback });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CommentForm);